// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "InventSum"
const create = function () {
  return {
    content_type: "muji"
  }
}
const descriptor = {
  name: {
    type: "string",
    required: true,
    validator: (rule, value) => value === "muji"
  },
  age: {
    type: "number",
    asyncValidator: (rule, value) => {
      return new Promise((resolve, reject) => {
        api
          .request({
            url: biz_data_helper.get_endpoint("test_fetch").url,
            parameters: {
              c: "a666"
            }
          })
          .then(res => {


            if (value == res.data[0].echo) {
              resolve(res)
            } else {
              reject("测试没通过")
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [{
    key: "id",
    label: "编号",
    sortable: true,
    thStyle: {
      width: "60px"
    }
  },

  {
    key: "dataAreaId",
    label: "内部公司编码",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "otherDataAreaId",
    label: "公司账户",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "CompanyName",
    label: "公司名称",
    sortable: true,
    thStyle: { width: "8rem" },
    type: "short"
  },
  {
    key: "ItemId",
    label: "物料编号",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "NameAlias",
    label: "物料名称",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "VariantName",
    label: "变型名称",
    sortable: true,
    thStyle: {
      width: "8rem"
    }
  },
  {
    key: "TEC_CustAccount",
    label: "客户账户",
    sortable: true,
  },
  {
    key: "SEI_Name",
    label: "客户名称",
    sortable: true,
  },
  {
    key: "OnOrder",
    label: "在单",
    sortable: true,
    type: "number"
  },
  {
    key: "Ordered",
    label: "已订购",
    sortable: true,
    type: "number"
  },
  {
    key: "AvailOrdered",
    label: "可用合计",
    sortable: true,
    type: "number"
  },
  {
    key: "AvailPhysical",
    label: "实际库存",
    sortable: true,
    type: "number"
  },
  {
    key: "PhysicalValue",
    label: "实际成本额",
    sortable: true,
    type: "number"
  }
  ],
  inventTable_fields: [{
    key: "ItemId",
    label: "物料编号",
  },
  {
    key: "NameAlias",
    label: "物料名称",
  },
  {
    key: "VariantName",
    label: "变型名称",
  },
  {
    key: "DW_InventUnitId",
    label: "单位",
  },
  {
    key: "TEC_CustAccount",
    label: "客户账户",
  },
  {
    key: "DW_CustName",
    label: "客户名称",
  }
  ],
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {

  ///get
  async getData(_params) {
    const biz_data = new biz_data_helper.base_entity_helper(
      "get_InvenSumAndItemsInfo", {}, {}
    )
    let _fields = _.map(fields.default, "key")
    _fields.push("SourceType")
    let result = await biz_data
      .execAction({
        params: _params,
        fields: _fields,
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
    // let result = await biz_data
    //   .selectAction({
    //     params: _params,
    //     fields: _.map(fields.default, "key")
    //   })
    //   .run();
    //
    // if (
    //   result &&
    //   result[0].result &&
    //   result[0].result.data &&
    //   result[0].result.data.ActionResult &&
    //   result[0].result.data.ActionResult.Result &&
    //   result[0].result.data.ActionResult.Result.Data.length > 0
    // ) {
    //   return result[0].result.data.ActionResult.Result.Data;
    // } else {
    //   return null;
    // }
  }
}
export {
  biz_data, dataForm, fields,
  methods, rules
};

